import { ParticipantList } from '../../squiz/common/index.js'
import { Box, Dialog } from '../'

export const ParticipantsDialog = ({ open, onClose }) => (
  <Dialog open={open} onClose={onClose} className="mobile-only">
    <Box height="75dvh" fullWidth>
      <ParticipantList />
    </Box>
  </Dialog>
)